var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-header u-clear" },
    [
      _c("div", { staticClass: "icon u-fl" }, [_vm._t("icon")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons u-clear u-fr" },
        [_vm._t("buttons")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title u-ff" }, [_vm._t("title")], 2),
      _vm._v(" "),
      _c("ui-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "loader"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }